import { getOfferName } from './title/getOfferName';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isTop } from './isTop';
import { isPremium } from './isPremium';

export const subtitle: TComputedPropMapper<string | undefined> = (props, ctx) => {
  if ((isTop(props, ctx) || isPremium(props, ctx)) && Boolean(props.offer.title)) {
    return getOfferName(props.offer);
  }

  return undefined;
};
